import React, { useEffect, useState } from "react";
import Main from "../../../layout/main/Main";
import { Link, useSearchParams } from "react-router-dom";
import {
	AntdButton,
	ButtonContainer,
	ChildrenContainer,
	ContentShell,
	PageContainer,
	PageHeaderBlock,
	PageSub,
	PageTitle,
	TitleBlock,
} from "./styles";
import MarketProductsList from "./product/list/MarketProductsList";
import { Prices } from "../../seller";

export default function MarketProductsIndex() {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [filter, setFilter] = useState("PRODUCTS");
	const [selectedClient, setSelectedClient] = useState(null);

	const get_filter = () => {
		setFilter(
			localStorage.getItem("marketProductsIndexFilter")
				? localStorage.getItem("marketProductsIndexFilter")
				: "PRODUCTS",
		);
	};

	const get_selected_client = () => {
		const clientFromStorage = localStorage.getItem("selectedClient");
		setSelectedClient(clientFromStorage ?? "");
	};

	useEffect(() => {
		get_filter();
		get_selected_client();
	}, [selectedClient]);

	const changeFilter = (value) => {
		setFilter(value);
		localStorage.setItem("marketProductsIndexFilter", value);
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						{uri ? "Productos y ofertas" : "Productos y Precios"}
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<PageContainer>
					<PageHeaderBlock>
						<TitleBlock>
							<PageTitle>
								{uri ? "Productos y Ofertas" : "Productos y Precios"}
							</PageTitle>
							<PageSub>
								Gestioná productos, listas de precios y ofertas desde un solo
								lugar
							</PageSub>
						</TitleBlock>

						<ButtonContainer>
							<AntdButton
								$active={filter === "PRODUCTS"}
								onClick={() => changeFilter("PRODUCTS")}
							>
								Productos OT
							</AntdButton>

							{selectedClient && selectedClient !== "" && (
								<AntdButton
									$active={filter === "PRICELIST"}
									onClick={() => changeFilter("PRICELIST")}
								>
									Lista de Precios OT
								</AntdButton>
							)}
						</ButtonContainer>
					</PageHeaderBlock>

					<ContentShell>
						<ChildrenContainer>
							{filter === "PRODUCTS" && (
								<MarketProductsList
									selectedClient={selectedClient}
									setSelectedClient={setSelectedClient}
									uri={uri}
								/>
							)}
							{filter === "PRICELIST" && <Prices clientId={selectedClient} />}
						</ChildrenContainer>
					</ContentShell>
				</PageContainer>
			</Main.Body>
		</Main>
	);
}
